import React from "react";
import { graphql, Link } from "gatsby";
import dayjs from "dayjs";
import { use100vh } from "react-div-100vh";

// Utils
import {
  checkColorScheme,
  returnColorScheme,
} from "../../components/utils/color-scheme";
import { checkEventDate } from "../../components/utils/check-event-date";

// Previews
import { withPrismicPreview } from "gatsby-plugin-prismic-previews";

// Components
import { Breadcrumbs } from "../../components/breadcrumbs/breadcrumbs";
import {
  PageContainer,
  SectionPages,
  SectionContent,
  Grid3,
  ResourceBlock,
} from "../../components/containers/page-components";
import { WhatsOnFilters } from "../../components/filters/whats-on-filters";
import { WhatsOnBlock } from "../../components/modules/whats-on-block";

// Hooks
import { useWhatsOn } from "../../components/hooks/useWhatsOn";
import { useMediaQuery } from "../../components/hooks/useMediaQuery";

// SEO
import { PageSeo } from "../../components/seo/page-seo";

const Event = ({ data, location }) => {
  // Media Query
  let isDesktop = useMediaQuery("(min-width: 961px)");

  // Window Height
  const height = use100vh();

  // Data
  const whatsOnData = useWhatsOn();

  const articleColorsArray = whatsOnData
    .filter((item) => item.data.post_type === `Event`)
    .filter((item) => checkEventDate(item.data.end_date) === false)
    .sort((a, b) =>
      dayjs(b.data.start_date).isAfter(dayjs(a.data.start_date)) ? 1 : -1
    )
    .map((item, index) => {
      return (item = {
        id: item.id,
        color: checkColorScheme(index),
      });
    });

  const content = whatsOnData
    .filter((item) => item.data.post_type === `Event`)
    .filter((item) => checkEventDate(item.data.end_date) === false)
    .sort((a, b) =>
      dayjs(b.data.start_date).isAfter(dayjs(a.data.start_date)) ? 1 : -1
    )
    .map((item, index) => (
      <WhatsOnBlock
        key={`single-whats-on-event-post-block-${item.id}`}
        index={index}
        id={`single-whats-on-event-post-block-${item.id}`}
        url={item.url}
        thumbnail={item.data.image_thumbnail}
        mobileThumbnail={item.data.mobileThumbnail}
        title={item.data.title.richText}
        startDate={item.data.start_date}
        endDate={item.data.end_date}
        type={item.data.post_type}
        hideDate={item.data.hide_date}
        pageType={`event`}
        isDesktop={isDesktop}
        fill={returnColorScheme(item.id, articleColorsArray)}
        ticketLink={
          item.data.ticket_link !== undefined
            ? item.data.ticket_link !== null
              ? item.data.ticket_link.url
              : null
            : null
        }
        fetchpriority={index === 0 ? `high` : ``}
        videoThumbnail={
          item.data.video_thumbnail !== null ? item.data.video_thumbnail : null
        }
        thumbnailType={
          item.data.image_or_video_thumbnail === true ? `image` : `video`
        }
      />
    ));

  return (
    <>
      <PageSeo
        seoTitle={`Event - Studio Voltaire`}
        seoText={null}
        seoImage={null}
      />

      <PageContainer pageType={`whats-on-event`}>
        <div className="breadcrumb-page-container-with-filters spacer-40 mobile-spacer-15">
          <Breadcrumbs
            crumbs={
              <>
                <Link to={data.prismicWhatsOnOverview.url}>What's On →</Link>{" "}
                <Link to={`/whats-on-type/event/`}>
                  <h1>Event</h1>
                </Link>
              </>
            }
          />

          <WhatsOnFilters location={location} />
        </div>

        <SectionPages className="event-layout" height={height}>
          <Grid3>{content}</Grid3>
        </SectionPages>
      </PageContainer>
    </>
  );
};

export default withPrismicPreview(Event);

export const query = graphql`
  {
    prismicWhatsOnOverview {
      url
      data {
        title {
          text
        }
      }
    }
  }
`;
